import { MobileScreenContext } from "@/shared/providers/MobileScreenProvider/context";
import { useContext } from "react";

export const useMobileScreen = () => {
  const context = useContext(MobileScreenContext);
  if (!context)
    throw new Error("useMobileScreen context must be used within Provider");
  return context;
};
